import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button/Button";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackSamplesRetailerSampleRequestButtonWebView } from "@faire/web-api--source/events/samples/view/retailerSampleRequestButtonWeb";
import React, { Suspense } from "react";
import styled from "styled-components";
import { LazySamplesRequestModal } from "./LazySamplesRequestModal";
import { SamplesRequestStoreProvider } from "./SamplesRequestStore";
export var RequestSamplesCTA = function(param) {
    var brandToken = param.brandToken, productToken = param.productToken, samplesBannerDetails = param.samplesBannerDetails;
    var viewport = useViewport();
    var _React_useState = _sliced_to_array(React.useState(false), 2), showSamplesModal = _React_useState[0], setShowSamplesModal = _React_useState[1];
    var title = samplesBannerDetails.title, message = samplesBannerDetails.message, buttonText = samplesBannerDetails.buttonText, ctaLink = samplesBannerDetails.ctaLink, ctaText = samplesBannerDetails.ctaText;
    var viewRef = useDoActionWhenVisible(function() {
        trackSamplesRetailerSampleRequestButtonWebView(productToken !== undefined ? "PDP_BANNER" : "BRAND_PAGE_BANNER", brandToken, productToken !== null && productToken !== void 0 ? productToken : "");
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showSamplesModal ? /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(SamplesRequestStoreProvider, {
                    children: /*#__PURE__*/ _jsx(LazySamplesRequestModal, {
                        brandToken: brandToken,
                        productToken: productToken,
                        source: productToken !== undefined ? "PDP" : "BRAND",
                        onClose: function() {
                            setShowSamplesModal(false);
                        }
                    })
                })
            }) : null,
            /*#__PURE__*/ _jsxs(Container, {
                ref: viewRef,
                "data-test-id": "samples-request-cta",
                onClick: function() {
                    // this banner should be clickable only on mobile
                    if (viewport.isMobile) {
                        setShowSamplesModal(true);
                    }
                },
                children: [
                    /*#__PURE__*/ _jsxs(Column, {
                        justify: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansMedium",
                                children: title
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "paragraphSansRegular",
                                children: [
                                    message,
                                    " ",
                                    /*#__PURE__*/ _jsx(EmbeddedLink, {
                                        onClick: function(e) {
                                            e.stopPropagation();
                                        },
                                        linkTo: ctaLink,
                                        children: ctaText
                                    })
                                ]
                            })
                        ]
                    }),
                    viewport.isMobile ? /*#__PURE__*/ _jsx(Chevron, {
                        direction: "right"
                    }) : /*#__PURE__*/ _jsx(NoWrapButton, {
                        onClick: function() {
                            return setShowSamplesModal(true);
                        },
                        "data-test-id": "request-samples-cta",
                        children: buttonText
                    })
                ]
            })
        ]
    });
};
var Container = styled(Row).attrs({
    justify: "space-between",
    align: "center",
    gap: "1x"
}).withConfig({
    componentId: "sc-a1afad67-0"
})([
    "width:100%;background:",
    ";padding:",
    ";"
], Decorative.tint.orange, getSpacing("2x"));
var NoWrapButton = styled(Button).attrs({
    variant: "primary"
}).withConfig({
    componentId: "sc-a1afad67-1"
})([
    "white-space:nowrap;"
]);
